import { Suspense, useState } from 'react'
import {
  Card,
  Grid,
  Heading,
  Spinner,
  Layout,
} from '@enterprise-ui/canvas-ui-react'
import { useMain } from '../main/useMain'
import DownloadItemView from './download'
import Instructions from './Instructions'
import UploadSpreadsheet from './upload'
import { BulkHeader } from './BulkHeader'
import UploadHistory from './uploadHistory'
import '../../styles/customStyles.scss'

/**
 * BulkItem Landing Page
 * Functionality for downloading & uploading item data in bulk.
 *
 * @component
 * @returns {JSX.Element} The rendered Bulk Item page.
 *
 * @description
 * - Contains two main sections:
 *   1. Left section : Includes components for downloading item data and uploading spreadsheets.src/views/bulkItem/uploadHistory/index.jsx
 *
 *   2. Right section : Displays instructions for the user.
 */
const BulkItem = () => {
  const { getUserProfile, loading } = useMain()
  const [uploadCounter, setUploadCounter] = useState(0)

  const handleUploadChange = () => {
    // Increment a counter or trigger an identifier to notify UploadHistory
    setUploadCounter((prev) => prev + 1)
  }
  return (
    <Suspense fallback={<Spinner />}>
      <Layout.Body
        data-testid="dashboard-page"
        includeRail
        className="layout-body-section"
      >
        {loading || !getUserProfile ? (
          <Grid.Container>
            <Grid.Item>
              <Heading size={4}>
                <Spinner size="inline" /> Loading bulk item data ...
              </Heading>
            </Grid.Item>
          </Grid.Container>
        ) : (
          <>
            <BulkHeader />
            <Card className="hc-bg-grey07 hc-pa-dense hc-mt-dense">
              <Grid.Container style={{ minHeight: 200 }}>
                <Grid.Item
                  xs={8}
                  className="border-right-grey-thin hc-mt-md hc-mb-md hc-pt-xs hc-pb-xs"
                >
                  <Card className="hc-ml-dense hc-mr-dense">
                    <DownloadItemView />
                  </Card>
                  <Card className="hc-ml-dense hc-mr-dense">
                    <UploadSpreadsheet
                      handleUploadChange={handleUploadChange}
                    />
                  </Card>
                </Grid.Item>
                <Grid.Item
                  xs={4}
                  className="hc-mt-md hc-mb-md hc-pt-xs hc-pb-xs"
                >
                  <Card elevation="0" className="hc-pa-dense hc-bg-grey07">
                    <Instructions />
                  </Card>
                </Grid.Item>
              </Grid.Container>
            </Card>
            <UploadHistory isFileuploaded={uploadCounter} />
          </>
        )}
      </Layout.Body>
    </Suspense>
  )
}

export default BulkItem
